import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MangaCard from '@/components/base/MangaCard';
import { allManga, getHotManga, getFeaturedManga, getNewManga } from '@/mocks/manga';
import { categories } from '@/mocks/categories';

const featuredManga = getFeaturedManga();
const hotManga = getHotManga();
const newManga = getNewManga();

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '178漫画网',
    url: 'http://91cghlw.cn/',
    description: '在178漫画网畅享满溢游泳池漫画的免费下拉式阅读，滑动屏幕即可流畅浏览精彩剧情，无需注册付费，随时沉浸在这个充满青春气息的泳池故事中。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://91cghlw.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '178漫画网的漫画是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，178漫画网上的所有漫画都是免费阅读的，无需注册或付费，您可以直接在线浏览任意漫画的全部章节，享受纯净的阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在178漫画网阅读满溢游泳池漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以在178漫画网首页或分类页面找到满溢游泳池漫画，点击进入详情页后选择任意章节即可开始阅读。我们采用下拉式阅读模式，滑动屏幕即可流畅浏览，无需翻页等待。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网全面适配电脑、平板和手机等各类设备。无论是在桌面端还是移动端，您都可以获得流畅的漫画阅读体验。下拉式阅读模式在手机端体验尤为出色。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网有哪些漫画分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网拥有丰富的漫画分类，包括青春校园、热血运动、恋爱甜宠、日常搞笑、奇幻冒险、悬疑推理、古风仙侠、科幻未来等，满足不同读者的阅读偏好。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网保持高速更新，热门连载漫画通常每日或每周更新，确保读者能够第一时间阅读到最新章节。您可以通过首页的"最新上架"区域查看最近更新的漫画。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20watercolor%20style%20swimming%20pool%20with%20sunlight%20reflecting%20on%20blue%20water%20surface%2C%20summer%20vibe%2C%20school%20swimming%20pool%20setting%2C%20abstract%20artistic%20style%2C%20gentle%20gradient%20from%20light%20blue%20to%20white%2C%20dreamy%20atmosphere%2C%20minimal%20composition%2C%20wide%20landscape&width=1600&height=700&seq=hero-bg-home&orientation=landscape"
                alt="178漫画网"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
            </div>
            <div className="relative z-10 w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-16 md:py-24">
                <div className="w-full lg:w-2/5 text-center lg:text-left">
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight">
                    满溢游泳池
                  </h1>
                  <p className="mt-4 text-base md:text-lg text-white/80 leading-relaxed">
                    在178漫画网畅享满溢游泳池漫画的免费下拉式阅读，滑动屏幕即可流畅浏览精彩剧情，无需注册付费，随时沉浸在这个充满青春气息的泳池故事中。
                  </p>
                  <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                    <Link
                      to="/article/manga-1"
                      className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer inline-flex items-center gap-2"
                    >
                      开始阅读
                      <i className="ri-arrow-right-up-line"></i>
                    </Link>
                    <Link
                      to="/category/school-life"
                      className="px-8 py-3 bg-white/15 text-white border border-white/30 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
                    >
                      浏览全部分类
                    </Link>
                  </div>
                </div>
                <div className="w-full lg:w-3/5">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2 sm:col-span-1">
                      <div className="relative rounded-2xl overflow-hidden aspect-[3/4]">
                        <img
                          src="https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20swimming%20pool%20with%20two%20teenagers%2C%20bright%20summer%20sunlight%2C%20blue%20water%20reflections%2C%20youthful%20energy%2C%20clean%20anime%20art%2C%20vibrant%20colors%2C%20romantic%20summer%20atmosphere&width=600&height=800&seq=hero-main-manga&orientation=portrait"
                          alt="满溢游泳池漫画"
                          title="满溢游泳池 - 178漫画网"
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
                          <span className="text-white text-sm font-medium bg-accent-500/90 px-3 py-1 rounded-full whitespace-nowrap">
                            人气TOP1
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1 flex flex-col gap-4">
                      <div className="relative rounded-2xl overflow-hidden aspect-[16/9]">
                        <img
                          src="https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20basketball%20game%20action%2C%20dynamic%20dunk%20pose%2C%20school%20gymnasium%2C%20intense%20competition%2C%20anime%20art%20style%2C%20bright%20colors&width=600&height=340&seq=hero-sub-01&orientation=landscape"
                          alt="篮球少年无悔"
                          title="篮球少年无悔 - 178漫画网"
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 to-transparent">
                          <span className="text-white text-xs bg-secondary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
                            热血运动
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                          <img
                            src="https://readdy.ai/api/search-image?query=Manga%20style%20romantic%20scene%20under%20cherry%20blossom%2C%20two%20characters%20in%20school%20uniform%2C%20pink%20petals%2C%20soft%20lighting%2C%20shojo%20art&width=300&height=375&seq=hero-sub-02&orientation=portrait"
                            alt="初恋这件小事"
                            title="初恋这件小事 - 178漫画网"
                            className="w-full h-full object-cover object-top"
                          />
                          <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70 to-transparent">
                            <span className="text-white text-xs bg-accent-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
                              恋爱甜宠
                            </span>
                          </div>
                        </div>
                        <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                          <img
                            src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20warrior%20with%20dragon%20spirit%2C%20ancient%20costume%2C%20glowing%20aura%2C%20epic%20atmosphere%2C%20manhua%20style&width=300&height=375&seq=hero-sub-03&orientation=portrait"
                            alt="斗罗大陆外传"
                            title="斗罗大陆外传 - 178漫画网"
                            className="w-full h-full object-cover object-top"
                          />
                          <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70 to-transparent">
                            <span className="text-white text-xs bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
                              奇幻冒险
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Featured Hot Manga */}
          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="flex items-end justify-between mb-8">
                  <div>
                    <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
                      本周热推
                    </h2>
                    <p className="mt-2 text-sm text-foreground-500">
                      千万读者都在追的热门漫画，不容错过
                    </p>
                  </div>
                  <Link
                    to="/category/school-life"
                    className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查看全部
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {featuredManga.map((manga, idx) => (
                    <div key={manga.id} className={idx === 0 ? 'lg:col-span-1 lg:row-span-2' : ''}>
                      <MangaCard manga={manga} variant={idx === 0 ? 'featured' : 'default'} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-10 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">
                  探索漫画分类
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl hover:bg-primary-50 transition-colors cursor-pointer"
                    >
                      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                        <i className="ri-book-open-line text-xl"></i>
                      </div>
                      <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                        {cat.name}
                      </span>
                      <span className="text-xs text-foreground-400">
                        {cat.mangaCount}部作品
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Latest Updates */}
          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
                  <div className="lg:w-1/3">
                    <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 leading-tight">
                      新鲜上架
                    </h2>
                  </div>
                  <div className="lg:w-2/3">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      最新更新的漫画章节已经为你整理好了，热门连载每日更新，让你第一时间追到最精彩的剧情。下拉式阅读体验，流畅到停不下来。
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                  <div className="lg:col-span-1">
                    <div className="bg-foreground-900 rounded-2xl p-6 h-full flex flex-col justify-between relative overflow-hidden">
                      <div className="absolute inset-0 opacity-15">
                        <img
                          src="https://readdy.ai/api/search-image?query=Abstract%20watercolor%20swimming%20pool%20with%20ripples%2C%20blue%20and%20teal%20gradient%2C%20minimal%20artistic%20style%2C%20soft%20texture%2C%20summer%20vibe&width=500&height=600&seq=latest-featured&orientation=portrait"
                          alt=""
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="relative z-10">
                        <span className="px-3 py-1 bg-accent-500 text-white text-xs rounded-full whitespace-nowrap">
                          编辑精选
                        </span>
                        <h3 className="text-2xl font-bold text-white mt-4">满溢游泳池</h3>
                        <p className="text-sm text-white/70 mt-2 leading-relaxed">
                          本周更新至第48话「夏日终曲」，全国大赛进入白热化阶段！林晓雨与陈默的双人混合接力能否突破校史纪录？快来一睹为快！
                        </p>
                      </div>
                      <div className="relative z-10 mt-4">
                        <Link
                          to="/article/manga-1"
                          className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-foreground-900 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/90 transition-colors cursor-pointer"
                        >
                          立即阅读
                          <i className="ri-arrow-right-line"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-2">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {newManga.map((manga) => (
                        <MangaCard key={manga.id} manga={manga} variant="default" />
                      ))}
                      {hotManga.slice(0, 2).map((manga) => (
                        <MangaCard key={manga.id} manga={manga} variant="default" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Reader Testimonials */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10">
                  <div className="inline-flex items-center gap-2 mb-3">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    <span className="text-xs text-foreground-500 uppercase tracking-wider">读者评价</span>
                  </div>
                  <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
                    读者都在说
                  </h2>
                  <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                    来自全国漫迷的真实评价，看看大家为什么喜欢在178漫画网看漫画
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {[
                    {
                      name: '小贝壳',
                      location: '上海',
                      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20round%20face%2C%20big%20eyes%2C%20pink%20hair%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
                      rating: 5,
                      title: '画风超赞，剧情上头',
                      comment: '满溢游泳池真的太好看了！画风清新细腻，泳池场景的光影处理简直绝了。林晓雨和陈默的感情线也让人超级上头，每周期待更新已经成了我的日常！',
                    },
                    {
                      name: '追漫达人阿杰',
                      location: '北京',
                      avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%2C%20short%20dark%20hair%2C%20sharp%20eyes%2C%20casual%20style%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
                      rating: 5,
                      title: '下拉式阅读太方便了',
                      comment: '之前在别的网站看漫画要一页一页翻，178漫画网的下拉式阅读真的太爽了！滑一下就能看下一话，躺着看漫画的体验直接拉满。分类也很全，各种类型都有。',
                    },
                    {
                      name: '樱花下的猫',
                      location: '广州',
                      avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20girl%20avatar%2C%20long%20brown%20hair%2C%20gentle%20smile%2C%20warm%20colors%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
                      rating: 4,
                      title: '免费良心网站',
                      comment: '178漫画网真的良心，全部漫画免费看不用注册。我追了七八部漫画，更新速度快画质也好。青春校园分类里的作品都很好看，强烈安利给所有喜欢校园漫的朋友！',
                    },
                    {
                      name: '篮球少年_小周',
                      location: '深圳',
                      avatar: 'https://readdy.ai/api/search-image?query=Sporty%20anime%20style%20boy%20avatar%2C%20short%20spiky%20hair%2C%20energetic%20expression%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
                      rating: 5,
                      title: '热血漫看得很过瘾',
                      comment: '篮球少年无悔从第一话追到现在，剧情越来越燃！178的阅读体验流畅不卡顿，加载速度也快。热血运动类漫画在这里特别全，推荐给喜欢运动题材的朋友。',
                    },
                    {
                      name: '甜食控小雨',
                      location: '成都',
                      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%2C%20twin%20tails%2C%20happy%20smile%2C%20pastel%20colors%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish',
                      rating: 5,
                      title: '恋爱漫甜到掉牙',
                      comment: '甜品店的恋爱和初恋这件小事是我的最爱！画风甜到爆炸，每看一话心情都变好。178漫画网收藏功能也很好用，可以随时追更。希望更新再快点哈哈哈！',
                    },
                    {
                      name: '深夜推理家',
                      location: '杭州',
                      avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20style%20boy%20avatar%2C%20glasses%2C%20thoughtful%20expression%2C%20dark%20hair%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-06&orientation=squarish',
                      rating: 4,
                      title: '悬疑分类做得不错',
                      comment: '作为一个悬疑推理迷，178漫画网的悬疑分类深得我心。消失的她剧情层层推进，每一话都有新线索，根本停不下来。网页适配做得也很好，手机看很舒服。',
                    },
                  ].map((review, idx) => (
                    <div key={idx} className="bg-background-50 rounded-xl p-5">
                      <div className="flex gap-1 mb-3">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`ri-star-fill text-sm ${i < review.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                          ></i>
                        ))}
                      </div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-2">{review.title}</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-4">
                        {review.comment}
                      </p>
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                          <img
                            src={review.avatar}
                            alt={review.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div>
                          <p className="text-xs font-medium text-foreground-800">{review.name}</p>
                          <p className="text-xs text-foreground-400">{review.location}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16 md:py-24 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-2xl md:text-5xl font-heading text-foreground-900 leading-tight">
                  免费开启你的阅读之旅
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                  无需注册，无需付费，打开网页即可畅享流畅的下拉式漫画阅读体验。上千部精选漫画等你来发现。
                </p>
                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/article/manga-1"
                    className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer inline-flex items-center gap-2"
                  >
                    立即开始阅读
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-foreground-50 transition-colors cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
              <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:gap-8">
                {allManga.slice(0, 8).map((manga) => (
                  <Link
                    key={manga.id}
                    to={`/article/${manga.id}`}
                    className="w-20 h-28 md:w-24 md:h-32 rounded-xl overflow-hidden hover:scale-105 transition-transform cursor-pointer flex-shrink-0"
                  >
                    <img
                      src={manga.cover}
                      alt={manga.title}
                      title={`${manga.title} - 178漫画网`}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}